import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  Box,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonModel from "../../../components/dialog/Common";
import useDebounce from "../../../hooks/use.debounce";
import { formatPrice, getFormatedDate } from "../../../utils/common";
import { CustomSearchInput, FORM_SELECTFIELD_STYLES, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, SUBSCRIPTION_PRODUCT_TYPE, SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPE, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../../utils/constant";
import { getAllBrandForDropDown } from "../../brands/action";
import { getAllSubscriptions, updateSubscriptionStatus } from "../action";
import { resetSubscription, updateSubscription } from "../subscriptionSlice";
import CustomPagination from "../../../utils/CustomPagination";

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, isSticky } = props;
  const createSortHandler =
    (property) => (event) => {
      if (property === "action") {
        return;
      }
      onRequestSort(event, property);
    };

  const headCells = [
    {
      id: "plan",
      numeric: false,
      disablePadding: true,
      label: "Plan Name",
      type: "",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: "Plan Type",
      type: "",
    },
    {
      id: "products",
      numeric: false,
      disablePadding: true,
      label: "Type of Product",
      type: "",
    },
    {
      id: "Discount",
      numeric: false,
      disablePadding: true,
      label: "Discount(%)",
      type: "",
    },
    {
      id: "monthly",
      numeric: false,
      disablePadding: true,
      label: "Monthly(₹)",
      type: "",
    },

    {
      id: "quarterly",
      numeric: false,
      disablePadding: true,
      label: "Quarterly(₹)",
      type: "",
    },

    {
      id: "yearly",
      numeric: false,
      disablePadding: true,
      label: "Yearly(₹)",
      type: "",
    },
    {
      id: "lastUpdate",
      numeric: false,
      disablePadding: true,
      label: "Created Date",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Actions",
      type: "",
    },
  ];
  return (
    <TableHead className={`hideActionSort ${isSticky} `}>
      <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={null}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}


export default function Subscriptions(props) {
  const navigate = useNavigate();
  const states = useSelector((state) => state.app);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [open, setOpen] = useState(false);
  const [sticky, setSticky] = useState("");
  const [status, setStatus] = useState({ name: "", status: "", id: "" });
  const dispatch = useDispatch();
  const {
    limit,
    page,
    sort_key,
    totalPages,
    filters,
    listing,totalCount,
  } = useSelector((state) => state.subscriptionSlice);
  const debouncedSearch = useDebounce(filters.name, 500);
  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateSubscription({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );
    dispatch(getAllBrandForDropDown());
  };

  useEffect(() => {
    if (debouncedSearch || filters.name == "")
      dispatch(getAllSubscriptions())
  }, [debouncedSearch]);

  useEffect(() => {
    dispatch(getAllSubscriptions())
    // return () => dispatch(resetSubscription())
  }, []);

  const handleChange = (value) => {
    dispatch(updateSubscription({ page: value - 1 }));
    dispatch(getAllSubscriptions());
  };

  const handleSearch = (event) => {
    dispatch(updateSubscription({ filters: { ...filters, name: event.target.value } }));
  };

  const handleSearchClear = () => {
    dispatch(updateSubscription({ filters: { ...filters, name: "" } }));
    dispatch(getAllSubscriptions());
  };

  const handleChangePerPage = (event, value) => {
    dispatch(updateSubscription({ limit: event.target.value, page: 0 }));
    dispatch(getAllSubscriptions());
  };

  const tableRef = useRef();
  return (
    <>
      <Stack direction="row" alignItems="center" mb={4}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          flexWrap="wrap" gap={2}
          sx={{
            minHeight: '42px', paddingX: '16px', width: '100%'
          }}
        >
          <Typography className="page-title" variant="h1">Subscription Plan</Typography>
          <Stack direction="row" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap={2}>
            <CustomSearchInput
              className="inputSearch sContrl p-0"
              value={filters.name}
              placeholder={"Search here..."}
              handleSearch={handleSearch}
              clearSearch={handleSearchClear}
              startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
            />

            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters?.type || ''}
              name="status"
              onChange={(e) => {
                dispatch(updateSubscription({ filters: { ...filters, type: e.target.value } }));
                dispatch(getAllSubscriptions());
              }} displayEmpty
              defaultValue={""}
              justifyContent={"flex-end"}
              className="upperCase"
            >
              <MenuItem disabled value="" hidden>
                Plan Type
              </MenuItem>

              <MenuItem value=" " >
                Plan Type (All)
              </MenuItem>


              {SUBSCRIPTION_TYPE.map((v) => <MenuItem className="upperCase" key={v} value={v} >
                {v}
              </MenuItem>)}
            </Select>
            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters?.typeOfProducts || ''}
              name="status"
              onChange={(e) => {
                dispatch(updateSubscription({ filters: { ...filters, typeOfProducts: e.target.value } }));
                dispatch(getAllSubscriptions());
              }} displayEmpty
              defaultValue={""}
              justifyContent={"flex-end"}
              className="upperCase"
            >
              <MenuItem disabled value="" hidden>
                Type of Product
              </MenuItem>
              <MenuItem value=" " >
                Type of Product (All)
              </MenuItem>
              {SUBSCRIPTION_PRODUCT_TYPE.map((v) => <MenuItem className="upperCase" key={v} value={v} >
                {v}
              </MenuItem>)}
            </Select>
            <button className={states?.permissions?.subscription?.create != 1 ? "btnDisabled" : "btnPrimary"}
              disabled={states?.permissions?.subscription?.create != 1}
              onClick={() => navigate("/subscription/create")}
            >
              Create Plan
            </button>
            <Tooltip title="Refresh listing">
              <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', mt: 1.5 }}
                onClick={() => {
                  dispatch(updateSubscription({ filters: {} }))
                  dispatch(getAllSubscriptions());
                }} />
            </Tooltip>

          </Stack></Stack>

      </Stack>



      <Stack direction={"column"} gap={2}>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            border: '1px solid rgba(170, 170, 170, 0.3)',
          }}>
          <TableContainer ref={tableRef}>
            <Table
              aria-label="sticky table">
              <EnhancedTableHead
                isSticky={sticky}
                order={order}
                orderBy={sort_key}
                onRequestSort={handleRequestSort}
                numSelected={0}
                onSelectAllClick={function (

                ) {
                  throw new Error("Function not implemented.");
                }}
              />
              <TableBody>
                {listing && listing?.length ? (
                  listing?.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        sx={TABLE_BODY_ROW_MUI_STYLES}
                      >
                        <TableCell component="td" scope="row">
                          {row?.name || "N/A"}

                        </TableCell>
                        <TableCell component="td" scope="row">
                          {row?.type || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row">
                          {row?.typeOfProducts || "N/A"}
                        </TableCell>

                        <TableCell align="left">
                          {row?.totalDiscount || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          {row?.monthlyDiscountedRate ? formatPrice(row?.monthlyDiscountedRate) : (formatPrice(row?.monthlyRate) || "N/A")}
                        </TableCell>
                        <TableCell align="left">
                          {row?.quarterlyDiscountedRate ? formatPrice(row?.quarterlyDiscountedRate) : (formatPrice(row?.quarterlyRate) || "N/A")}
                        </TableCell>
                        <TableCell align="left">
                          {row?.yearlyDiscountedRate ? formatPrice(row?.yearlyDiscountedRate) : (formatPrice(row?.yearlyRate) || "N/A")}
                        </TableCell>
                        <TableCell align="left">
                          {row?.updatedDate ? getFormatedDate(row?.updatedDate, "DD MMMM YYYY") : "N/A"}

                        </TableCell>
                        <TableCell align="left">
                          {row.status ? <button className={row.status?.toLowerCase()}>{row.status || "N/A"}</button> : "N/A"}
                        </TableCell>
                        <TableCell sx={{ cursor: "pointer" }}>
                          <Stack direction={"row"}
                            sx={{
                              gap: '8px'
                            }}
                          >
                            <div className="actBtnGrps">
                              {states?.permissions?.subscriptions?.edit == 1 && row.status === SUBSCRIPTION_STATUS.DRAFT && <span className="editIcon" onClick={() => navigate(`/subscription/edit/${row.id}`)}>Edit</span>}
                              <span className="viewIcon" onClick={() => navigate("/subscription/details/" + row.id)}>View</span>
                              {row.status !== SUBSCRIPTION_STATUS.DISABLE && <>
                                <span style={{ color: `${row.status === SUBSCRIPTION_STATUS.DRAFT ? "#22c55e" : "#ef3f3f"}` }} onClick={() => {
                                  setStatus({ name: row.name, status: row.status === SUBSCRIPTION_STATUS.DRAFT ? SUBSCRIPTION_STATUS.LIVE : SUBSCRIPTION_STATUS.DISABLE, id: row.id });
                                  setOpen(true)
                                }}>{row.status === SUBSCRIPTION_STATUS.DRAFT ? "Activate" : "Disable"}</span></>}
                            </div>

                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow colSpan={10}>
                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3"
                      >
                        No Data found!
                      </Typography>

                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

          </TableContainer>
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              handleChangePerPage={handleChangePerPage}
              limit={limit}
              totalCount={totalCount}
              listingCount={listing?.length}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
          <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={""}
            dialogPara={`Are you sure, you want to ${status.status} this “${status.name}” plan ? `}
            nvYes={"Confirm"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              dispatch(updateSubscriptionStatus(status.id, status.status));
              setOpen(false);
            }}
          />
        </Box>




      </Stack>

    </>
  );
}
